import request from './request'

/**
 * 根据名称列表获取分类信息
 * @param {Array} nameList 分类名称列表
 */
export function getCategoryInfoByNames(nameList) {
  return request({
    url: '/api/index/getCategoryInfoByNames',
    method: 'post',
    data: nameList

  })
}
